import React from 'react';

export default function TenantInformationCard({tenant_data}) {
    return(
        <div class="card">
            <div class="header">
                <h4 class="card-icon-title">
                    <span class="card-box-icon blue-card-icon-circle">
                        <i class="pe-7s-call" />
                    </span>
                    <span>
                        Tenant Contact Information
                    </span>
                </h4>
                <p class="category" />
            </div>
            <div class="row">
                <div class="content">
                    {tenant_data != null ? (
                        <div>
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label>Name</label>
                                    <div class="clearfix"></div>
                                    {tenant_data.tenant_firstname}
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label>Phone</label>
                                    <div class="clearfix"></div>
                                    <a href={"tel:" + tenant_data.tenant_phone}>
                                        {orderData.tenant_data.tenant_phone}
                                    </a>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div class="col-md-10 col-md-offset-1">
                            <div class="form-group">
                                <p>No tenant information found.</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// app/helpers/Cards/TenantInformationCard.jsx